// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
 firebase: {
  apiKey: "AIzaSyBK1_5jRqLDHtIQP9Zd4j4e8RjiZVpcO60",
  authDomain: "prijavi-diskriminacija.firebaseapp.com",
  projectId: "prijavi-diskriminacija",
  storageBucket: "prijavi-diskriminacija.appspot.com",
  messagingSenderId: "745839258845",
  appId: "1:745839258845:web:cf1a18e8ab30ae2aa57f34",
  measurementId: "G-GSCJK9TWEG"
}
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
